import styled from "styled-components";
import { AnimationFixed } from "../Animation";

export const ModalBackdrop = styled("div")`
	opacity: 0.5;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1040;
	width: 100%;
	height: calc(100vh * 2);
	background-color: #000;
`;

export const Modal = styled("div")`
	min-height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: auto;
	pointer-events: auto;
`;

export const ModalDialog = styled("div")<{ width? }>`
	width: 100%;
	padding: 5px 8px;
	max-width: ${(props) => props.width || 288}px;

	@media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
		padding: 0px;
		max-width: ${(props) => props.width || 580}px;
	}
`;

export const ModalContent = styled("div")`
	position: relative;
	display: flex;
	flex-direction: column;
	left: 0;
	bottom: 0;
	right: 0;
	margin: 0;
	outline: 0;
	background-color: #fff;
	width: 100%;
	min-height: 48vh;
	overflow: hidden;
	padding: 40px;
	border-radius: 16px;

	@media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
		border-radius: 8px;
		width: auto;
		min-height: 0;
		overflow: visible;
	}
`;

export const ModalHeader = styled("div")`
	display: flex;
	justify-content: space-between;
	flex-direction: column;
`;

export const Title = styled("h3")`
	font-weight: 600;
	font-size: 30px;
	line-height: 1;
	text-align: center;
	margin-top: 0px;
	margin-bottom: 30px;
	color: ${(props) => props.theme.colors.Gray};
`;

export const Close = styled("button")`
	background: transparent;
	position: absolute;
	cursor: pointer;
	top: 18px;
	right: 18px;
	padding: 0;
	margin: 0;
	border: 0;
	line-height: 1;

	&:focus {
		outline: transparent;
	}
`;

export const ModalBody = styled("div")`
	position: relative;
	line-height: 1.75rem;

	@media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
		flex: 1 1 auto;
	}

	.rdt_Table {
		overflow: auto;
		min-height: 280px;
		max-height: 280px;
	}

	.rdt_TableHead {
		position: sticky;
		z-index: 10;
		top: 0;
		background-color: white;
		width: calc(100% + 6px);
		margin: 0px -3px 3px;
		padding: 0px 3px;
	}

	.data-table-extensions {
	}
`;

export const ModalFooter = styled("div")`
	padding: 0 0 24px;
`;

export const ModalAnimation = styled(AnimationFixed)`
	overflow-x: hidden;
	overflow-y: auto;
	outline: 0;
	pointer-events: auto;
`;
